// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'UNSED IMPORTS AND VARIABLES REMOVED'
// Modified Date : 04-08-2025
import { put, takeLatest, call, all } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	fetchParticularAutoLoanIndexDetailsFailure,
	fetchParticularAutoLoanIndexDetailsSuccess,
	fetchParticularAutoLoanIndexDetailsResponseChanged,
	createHDFCCreateIndividualQRCodeSuccess,
	createHDFCCreateIndividualQRCodeFailure,
	createHDFCCreateIndividualQRCodeResponseChanged,
	groupWiseAutoLoanListFailure,
	groupWiseAutoLoanListSuccess,
	groupWiseAutoLoanListResponseChanged,
	addAutoLoanIndexDisbursementResponseChanged,
	addAutoLoanIndexDisbursementSuccess,
	addAutoLoanIndexDisbursementFailure,
	fetchAutoLoanScheduleSuccess,
	fetchAutoLoanScheduleFailure,
	fetchAutoLoanSchedulResponseChanged,
	deleteParticularAutoLoanIndexSuccess,
	deleteParticularAutoLoanIndexFailure,
	deleteParticularAutoLoanIndexResponseChaanged,
} from './auto-loan-index-disbursement.action';
import AutoLoanIndexDisbursementTypes from './auto-loan-index-disbusement.types';
import {
	fetchParticularAutoLoanIndexDetails,
	createHDFCIndividualQRCode,
	groupWiseAutoLoanList,
	addAutoLoanIndexDisbursement,
	getautoLoanIndexScheduleDetail,
	deleteParticularAutoLoanIndexDetail,
} from './auto-loan-index-disbusement.services';

/** *********************  START FETCH LOAN INDEX DETAILS  ******************** */
export function* particularAutoLoanIndexDetails({ payload }: any) {
	try {
		const key = 'FetchParticularAutoLoanIndexDetails';
		const { databaseName, loanIndexID } = payload;
		const jsonData = {
			loanIndexID: loanIndexID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchParticularAutoLoanIndexDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchParticularAutoLoanIndexDetailsFailure(responseData.data));
		} else {
			yield put(fetchParticularAutoLoanIndexDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchParticularAutoLoanIndexDetailsFailure(error));
	}
}

export function* resetParticularAutoLoanIndexDetailsResponse() {
	yield put(fetchParticularAutoLoanIndexDetailsResponseChanged());
}

export function* onFetchParticularAutoLoanIndexDetails() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_START,
		particularAutoLoanIndexDetails,
	);
}

export function* onParticularAutoLoanIndexDetailsResponseReset() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_RESPONSE_RESET,
		resetParticularAutoLoanIndexDetailsResponse,
	);
}
/** *********************  END FETCH LOAN INDEX DETAILS  ******************** */

/*********** HDFC CREATE INDIVIDUAL QRCODE START ************************ */
export function* addHDFCQRCodeIndivialDeatil({ payload }: any) {
	try {
		const key = 'CreateNewIndividualQRForHDFCKey';
		const { loanIndexID, generalCompanyID, userID, loanIndexUID, databaseName } = payload;
		const jsonData = {
			LoanIndexID: loanIndexID,
			DatabaseName: databaseName,
			CompanyID: generalCompanyID,
			CreatedBy: userID,
			LoanIndexUID: loanIndexUID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(createHDFCIndividualQRCode, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createHDFCCreateIndividualQRCodeFailure(responseData.data));
		} else {
			yield put(createHDFCCreateIndividualQRCodeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createHDFCCreateIndividualQRCodeFailure(error));
	}
}

export function* resetcreateHDFCCreateIndividualQRCode() {
	yield put(createHDFCCreateIndividualQRCodeResponseChanged());
}

export function* onResetcreateHDFCCreateIndividualQRCode() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.HDFC_CREATE_INDIVIDUAL_QRCODE_START,
		addHDFCQRCodeIndivialDeatil,
	);
}

export function* onResetcreateHDFCCreateIndividualQRCodeResponseReset() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.HDFC_CREATE_INDIVIDUAL_QRCODE_RESPONSE_RESET,
		resetcreateHDFCCreateIndividualQRCode,
	);
}
/*********** HDFC CREATE INDIVIDUAL QRCODE END ************************ */

/*********** GROUP WISE AUTO LOAN LIST START ************************ */
export function* groupBasedAutoLoanIndexList({ payload }: any) {
	try {
		const key = 'FetchAllAutoLoanIndexListKey';
		const {
			companyID,
			databaseName,
			userLevel,
			branchID,
			centerID,
			groupID,
			type,
			userID,
			userRole,
			userRoleID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserLevel: userLevel,
			DatabaseName: databaseName,
			BranchID: branchID,
			LocationID: centerID,
			GroupID: groupID,
			Type: type,
			UserID: userID,
			UserRole: userRole,
			userRoleID: userRoleID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(groupWiseAutoLoanList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(groupWiseAutoLoanListFailure(responseData.data));
		} else {
			yield put(groupWiseAutoLoanListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(groupWiseAutoLoanListFailure(error));
	}
}

export function* resetGropWiseAutoLoanList() {
	yield put(groupWiseAutoLoanListResponseChanged());
}

export function* onResetGropWiseAutoLoanList() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.GROUP_WISE_AUTO_LOAN_LIST_START,
		groupBasedAutoLoanIndexList,
	);
}

export function* onResetGropWiseAutoLoanListResponseReset() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.GROUP_WISE_AUTO_LOAN_LIST_RESPONSE_RESET,
		resetGropWiseAutoLoanList,
	);
}
/*********** GROUP WISE AUTO LOAN LIST END ************************ */

/** ********************* START AUTO LOAN INDEX DISBURSEMENT ******************* */
export function* autoLoanIndexDisbursement({ payload }: any) {
	try {
		const key = 'CreateAutoLoanIndexKey';
		const LoanDisbursementArray = JSON.stringify(payload.loanDisbursementArray).replace(
			/"/g,
			"'",
		);
		const ProductInvestors = JSON.stringify(payload.productInvestors).replace(/"/g, "'");
		const {
			companyID,
			databaseName,
			disbursementDate,
			meetTime,
			transactionType,
			loanStatus,
			loanIndexID,
			isTopUpLoan,
			userID,
			memberThrift,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			Loandisbursementdate: disbursementDate,
			MeetupTime: meetTime,
			LoanIndexStatus: loanStatus,
			TransactionType: transactionType,
			LoanIndex: loanIndexID,
			IsTopUpLoan: isTopUpLoan,
			CreatedBy: userID,
			LoanDisbursementArray,
			MemberThrift: memberThrift,
			ProductInvestors,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanIndexDisbursement, encodeData);
		if (responseData.status === 200) {
			yield put(addAutoLoanIndexDisbursementSuccess(responseData.data));
		} else {
			yield put(addAutoLoanIndexDisbursementFailure(responseData.data));
		}
	} catch (error) {
		yield put(addAutoLoanIndexDisbursementFailure(error));
	}
}

export function* autoLoanIndexDetailResponse() {
	yield put(addAutoLoanIndexDisbursementResponseChanged());
}

export function* onAutoLoanIndexDisbursement() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.ADD_AUTO_LOAN_INDEX_DISBURSEMENT_START,
		autoLoanIndexDisbursement,
	);
}

export function* onAutoLoanIndexDisbursementResponseReset() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.ADD_AUTO_LOAN_INDEX_DISBURSEMENT_RESPONSE_RESET,
		autoLoanIndexDetailResponse,
	);
}
/** ********************* END AUTO LOAN INDEX DISBURSEMENT ******************** */

/** ********************* START AUTO LOAN INDEX SCHEDULE ******************* */
export function* autoLoanParticularScheduleDetail({ payload }: any) {
	try {
		const key = 'getAutoLoanScheduleKey';
		const { companyID, databaseName, loanIndexID, memberID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			LoanIndexID: loanIndexID,
			MemberID: memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getautoLoanIndexScheduleDetail, encodeData);
		if (responseData.status === '100') {
			yield put(fetchAutoLoanScheduleFailure(responseData.data));
		} else {
			yield put(fetchAutoLoanScheduleSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAutoLoanScheduleFailure(error));
	}
}

export function* autoLoanIndexScheduleDetailResponse() {
	yield put(fetchAutoLoanSchedulResponseChanged());
}

export function* onAutoLoanIndexScheduleResponse() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.GET_AUTO_LOAN_INDEX_SCHEDULE_START,
		autoLoanParticularScheduleDetail,
	);
}

export function* onAutoLoanIndexScheduleResponseReset() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.GET_AUTO_LOAN_INDEX_SCHEDULE_RESPONSE_RESET,
		autoLoanIndexScheduleDetailResponse,
	);
}
/** ********************* END AUTO LOAN INDEX SCHEDULE ******************** */

/** ********************* DELETE PARTICULLAR AUTO LOAN INDEX START ******************* */
export function* deleteAutoLoanParticullarIndex({ payload }: any) {
	try {
		const key = 'DeleteParticularAutoLoanIndexKey';
		const { companyID, databaseName, loanIndexID, userName, userID, userAccessBranchID } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			AutoLoanID: loanIndexID,
			UserName: userName,
			UserID: userID,
			UserAccessBranchID: userAccessBranchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteParticularAutoLoanIndexDetail, encodeData);
		if (responseData.status === '100') {
			yield put(deleteParticularAutoLoanIndexFailure(responseData.data));
		} else {
			yield put(deleteParticularAutoLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteParticularAutoLoanIndexFailure(error));
	}
}

export function* deleteParticularAutoLoanIndexResponse() {
	yield put(deleteParticularAutoLoanIndexResponseChaanged());
}

export function* onDeleteParticularAutoLoanIndexResponse() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.DELETE_PARTICULAR_AUTO_LOAN_INDEX_START,
		deleteAutoLoanParticullarIndex,
	);
}

export function* onDeleteParticularAutoLoanIndexResponseReset() {
	yield takeLatest(
		AutoLoanIndexDisbursementTypes.DELETE_PARTICULAR_AUTO_LOAN_INDEX_RESPONSE_RESET,
		deleteParticularAutoLoanIndexResponse,
	);
}
/** ********************* DELETE PARTICULLAR AUTO LOAN INDEX END ******************* */

export function* autoLoanIndexDisbursementSaga() {
	yield all([
		call(onFetchParticularAutoLoanIndexDetails),
		call(onParticularAutoLoanIndexDetailsResponseReset),
		call(onResetcreateHDFCCreateIndividualQRCode),
		call(onResetcreateHDFCCreateIndividualQRCodeResponseReset),
		call(onResetGropWiseAutoLoanList),
		call(onResetGropWiseAutoLoanListResponseReset),
		call(onAutoLoanIndexDisbursement),
		call(onAutoLoanIndexDisbursementResponseReset),
		call(onAutoLoanIndexScheduleResponse),
		call(onAutoLoanIndexScheduleResponseReset),
		call(onDeleteParticularAutoLoanIndexResponse),
		call(onDeleteParticularAutoLoanIndexResponseReset),
	]);
}
